import { Box, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { CulturaPragaReceituario } from "../../../types/api/comercial/pesquisar-cultura-praga-receituario";
import DialogSelectCultura from "./DialogSelectCultura";

export default function SelectCulturaReceituario({
    inputLabel,
    value,
    onChangeValue,
    agrotoxico_id,
    required = false,
    error = false,
    disabled = false,
    errorMessage = "Campo obrigatório"
}: SelectCulturaReceituarioProps) {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const CustomInputComponent = ({ value, onClick, disabled }: CustomInputComponent) => {
        const commonStyles = {
            display: "flex",
            width: '100%',
            padding: '8px 12px',
            height: "56px",
            cursor: disabled ? "not-allowed" : "pointer",
            backgroundColor: disabled ? "#f5f5f5" : "inherit",
            opacity: disabled ? 0.6 : 1
        }

        if (!value) return (
            <TextField
                {...{ onClick }}
                variant="outlined"
                fullWidth
                slotProps={{
                    input: { readOnly: true }
                }}
                disabled={disabled}
            />
        )

        return (
            <Box
                onClick={disabled ? undefined : onClick}
                sx={{ ...commonStyles, justifyContent: "center", flexDirection: 'column' }}
            >
                <Typography variant={"body1"}>
                    <b>
                        {`${value.nome_cultura ? `${value.nome_cultura}` : ""}`}
                    </b>
                </Typography>
                {
                    Boolean(value.praga_id) &&
                    <Typography variant="caption" color="gray" mt={-0.3}>
                        Praga: {value.nome_cientifico} - {value.nome_popular}
                    </Typography>
                }
            </Box>
        );
    }

    return (
        <>
            <TextField
                {...{ required, error }}
                fullWidth
                label={!Boolean(value) ? inputLabel : null}
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (!disabled && e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    inputLabel: { shrink: Boolean(value) },
                    input: {
                        readOnly: true,
                        inputComponent: () => (
                            <CustomInputComponent
                                {...{ value, disabled }}
                                onClick={() => !disabled && setOpenModal(true)}
                            />
                        )
                    }
                }}
                helperText={error ? errorMessage : ""}
                disabled={disabled}
            />

            {
                openModal &&
                <DialogSelectCultura
                    {...{ agrotoxico_id }}
                    open={openModal}
                    defValue={value}
                    handleClose={() => setOpenModal(false)}
                    onSubmitValue={onChangeValue}
                />
            }
        </>
    )
}

interface SelectCulturaReceituarioProps {
    inputLabel: string,
    value: Value,
    onChangeValue: OnChangeValue,
    required?: boolean,
    error?: boolean
    errorMessage?: string,
    agrotoxico_id: number
    disabled?: boolean
}

interface CustomInputComponent {
    disabled: boolean,
    value: Value,
    onClick: () => void
}

export type Value = CulturaPragaReceituario | null
export type OnChangeValue = (arg: CulturaPragaReceituario) => void